import { render, staticRenderFns } from "./ServerFilterableTable2.vue?vue&type=template&id=282777e5"
import script from "./ServerFilterableTable2.vue?vue&type=script&lang=js"
export * from "./ServerFilterableTable2.vue?vue&type=script&lang=js"
import style0 from "./ServerFilterableTable2.vue?vue&type=style&index=0&id=282777e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports